// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__KwRsE","column":"Checkbox_column__iVg3k","revers-direction":"Checkbox_revers-direction__csbGv"};